import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="combined-purchase-applications"
export default class extends Controller {
	static targets = [
		"template",
		"base",
		"text",
		"reason",
		"number",
		"delete_check",
		"item_ids",
		"text_submit",
		"credential_submit",
		"relearning_submit",
		"credential_template",
		"credential_base",
		"credential_number",
		"student_republish_reason",
		"register_numbers",
		"credential_delete_check",
		"relearning_number",
		"schooling_relearning_selects",
		"relearning_template",
		"relearning_base",
		"relearning_delete_check",
		"relearning_ids",
		"relearning_register_numbers",
		"law_tab",
		"junior_College_tab",
	]

	static values = {
		purchaseItemSearchUrl: String,
		purchaseUserSearchUrl: String,
	}

	connect() {
		this.set_value()
		this.set_credential()
		this.set_relearning()
		this.changeFacultyOfLawTab()
		this.baseTarget.style = "display:none;"
		this.credential_baseTarget.style = "display:none;"
		this.relearning_baseTarget.style = "display:none;"
		this.text_submitTarget.style = "display:none;"
		this.credential_submitTarget.style = "display:none;"
		this.relearning_submitTarget.style = "display:none;"
	}

	text_add() {
		const clone_id = this.textTarget.value
		const number = this.numberTarget.value
		if (!clone_id) {
			alert("テキストが未入力です。")
			return false
		} else if (this.judgement_added_text(clone_id)) {
			alert("そのテキストは追加済みです。")
			return false
		} else if (!number || number <= 0) {
			alert("1冊以上の冊数を入力してください。")
			return false
		} else {
			const clone_target = this.baseTarget.cloneNode(true)
			const clone_text_name = this.textTarget.textContent
			const clone_length = this.baseTargets.length
			clone_target.id = clone_id
			clone_target.querySelector("input").value = clone_id
			clone_target.querySelector(".text_name").textContent = clone_text_name
			clone_target.querySelector(".display_text_number").textContent = number
			this.fetchItemSearch(clone_id, clone_target)
			clone_target.querySelector(".purchase_item_id").value = clone_id
			clone_target.querySelector(
				".purchase_item_id"
			).id = `forms_combined_schools_purchase_applications_edit_texts_attributes_${clone_length}_purchase_item_id`
			clone_target.querySelector(
				".purchase_item_id"
			).name = `forms_combined_schools_purchase_applications_edit[texts_attributes][${clone_length}][purchase_item_id]`
			this.fetch_reason_kind(clone_target)
			clone_target.querySelector(
				".reason_kind"
			).id = `forms_combined_schools_purchase_applications_edit_texts_attributes_${clone_length}_reason_kind`
			clone_target.querySelector(
				".reason_kind"
			).name = `forms_combined_schools_purchase_applications_edit[texts_attributes][${clone_length}][reason_kind]`
			clone_target.querySelector(".text_number").value = number
			clone_target.querySelector(
				".text_number"
			).id = `forms_combined_schools_purchase_applications_edit_texts_attributes_${clone_length}_text_number`
			clone_target.querySelector(
				".text_number"
			).name = `forms_combined_schools_purchase_applications_edit[texts_attributes][${clone_length}][text_number]`
			clone_target.style = ""
			this.templateTarget.append(clone_target)
		}
	}

	delete_added_text() {
		if (this.judgement_checked(this.delete_checkTargets)) {
			if (confirm("選択したテキストを削除しますか？")) {
				this.delete_checkTargets.forEach((del) => {
					this.baseTargets.forEach((target) => {
						if (del.checked && target.id === del.value) {
							target.remove()
						}
					})
				})
			}
			this.set_value()
		} else {
			alert("削除するテキストを選択してください。")
		}
	}

	credential_add() {
		const register_number = this.credential_numberTarget.value
		const republish_reason = this.student_republish_reasonTarget.value
		if (this.judgement_added_credential(register_number)) {
			alert("その学生は追加済みです。")
			return false
		} else {
			const clone_target = this.credential_baseTarget.cloneNode(true)
			const clone_length = this.credential_baseTargets.length
			clone_target.id = register_number
			this.fetchSearchUser(
				register_number,
				republish_reason,
				clone_target,
				clone_length
			)
		}
	}

	delete_added_credential() {
		if (this.judgement_checked(this.credential_delete_checkTargets)) {
			if (confirm("選択した学生を削除しますか？")) {
				this.credential_delete_checkTargets.forEach((del) => {
					this.credential_baseTargets.forEach((target) => {
						if (del.checked && target.id === del.value) {
							target.remove()
						}
					})
				})
			}
			this.set_credential()
		} else {
			alert("削除する学生を選択してください。")
		}
	}

	relearning_add() {
		const register_number = this.relearning_numberTarget.value
		const purchase_item_id = this.schooling_relearning_selectsTarget.value
		const clone_target = this.relearning_baseTarget.cloneNode(true)
		const clone_length = this.relearning_baseTargets.length
		const clone_course_name =
			this.schooling_relearning_selectsTarget.textContent
		clone_target.id = register_number
		this.fetchRelearningSearchUser(
			register_number,
			purchase_item_id,
			clone_course_name,
			clone_target,
			clone_length
		)
	}

	delete_added_relearning() {
		if (this.judgement_checked(this.relearning_delete_checkTargets)) {
			if (confirm("選択した学生を削除しますか？")) {
				this.relearning_delete_checkTargets.forEach((del) => {
					this.relearning_baseTargets.forEach((target) => {
						if (del.checked && target.id === del.value) {
							target.remove()
						}
					})
				})
			}
			this.set_relearning()
		} else {
			alert("削除する学生を選択してください。")
		}
	}

	judgement_checked(targets) {
		let delete_flg = false
		targets.forEach((target) => {
			if (target.checked) {
				delete_flg = true
			}
		})
		return delete_flg
	}

	fetch_reason_kind(target) {
		this.reasonTargets.forEach((reason) => {
			if (reason.checked) {
				target.querySelector(".reason_kind").value = reason.value
			}
		})
	}

	judgement_added_text(clone_id) {
		let added_flg = false
		this.item_idsTargets.forEach((id) => {
			if (id.value === clone_id) {
				added_flg = true
			}
		})
		return added_flg
	}

	judgement_added_credential(register_number) {
		let added_flg = false
		this.register_numbersTargets.forEach((r_num) => {
			if (r_num.value === register_number) {
				added_flg = true
			}
		})
		return added_flg
	}

	set_value() {
		this.baseTargets.forEach((target, index) => {
			const del_id = target.querySelector(".purchase_item_id").value
			target.id = del_id
			target.querySelector("input").value = del_id
			target.querySelector(
				".purchase_item_id"
			).id = `forms_combined_schools_purchase_applications_edit_texts_attributes_${index}_purchase_item_id`
			target.querySelector(
				".purchase_item_id"
			).name = `forms_combined_schools_purchase_applications_edit[texts_attributes][${index}][purchase_item_id]`
			target.querySelector(
				".reason_kind"
			).id = `forms_combined_schools_purchase_applications_edit_texts_attributes_${index}_reason_kind`
			target.querySelector(
				".reason_kind"
			).name = `forms_combined_schools_purchase_applications_edit[texts_attributes][${index}][reason_kind]`
			target.querySelector(
				".text_number"
			).id = `forms_combined_schools_purchase_applications_edit_texts_attributes_${index}_text_number`
			target.querySelector(
				".text_number"
			).name = `forms_combined_schools_purchase_applications_edit[texts_attributes][${index}][text_number]`
		})
	}

	set_credential() {
		this.credential_baseTargets.forEach((target, index) => {
			const del_id = target.querySelector(".credential_register_number").value
			target.id = del_id
			target.querySelector("input").value = del_id
			target.querySelector(
				".credential_register_number"
			).id = `forms_combined_schools_purchase_applications_edit_credentials_attributes_${index}_c_register_number`
			target.querySelector(
				".credential_register_number"
			).name = `forms_combined_schools_purchase_applications_edit[credentials_attributes][${index}][c_register_number]`
			target.querySelector(
				".republish_reason"
			).id = `forms_combined_schools_purchase_applications_edit_credentials_attributes_${index}_republish_reason`
			target.querySelector(
				".republish_reason"
			).name = `forms_combined_schools_purchase_applications_edit[credentials_attributes][${index}][republish_reason]`
		})
	}

	set_relearning() {
		this.relearning_baseTargets.forEach((target, index) => {
			const del_id = target.querySelector(".relearning_delete").value
			target.id = del_id
			target.querySelector("input").value = del_id
			target.querySelector(
				".relearning_register_number"
			).id = `forms_combined_schools_purchase_applications_edit_relearnings_attributes_${index}_r_register_number`
			target.querySelector(
				".relearning_register_number"
			).name = `forms_combined_schools_purchase_applications_edit[relearnings_attributes][${index}][r_register_number]`
			target.querySelector(
				".purchase_item_id"
			).id = `forms_combined_schools_purchase_applications_edit_relearnings_attributes_${index}_purchase_item_id`
			target.querySelector(
				".purchase_item_id"
			).name = `forms_combined_schools_purchase_applications_edit[relearnings_attributes][${index}][purchase_item_id]`
		})
	}

	fetchItemSearch(item_id, target) {
		const query = new URLSearchParams()
		query.set("q[id_eq]", item_id)
		fetch(`${this.purchaseItemSearchUrlValue}?${query}`)
			.then((response) => response.json())
			.then((data) => {
				let amount_value = ``
				data.forEach((item) => {
					amount_value = `${item.amount}`
				})
				target.querySelector(".text_amount").textContent = amount_value
			})
	}

	fetchSearchUser(register_number, republish_reason, target, clone_length) {
		const query = new URLSearchParams()
		query.set("register_number", register_number)
		fetch(`${this.purchaseUserSearchUrlValue}?${query}`)
			.then((response) => response.text())
			.then((data) => {
				if (data == "") {
					alert("対象の学生が存在しません。")
					return false
				} else {
					let user_name = data
					target.querySelector(".credential_student_name").textContent =
						user_name
					target.querySelector("input").value = register_number
					target.querySelector(".credential_register_number").value =
						register_number
					target.querySelector(
						".credential_register_number"
					).id = `forms_combined_schools_purchase_applications_edit_credentials_attributes_${clone_length}_c_register_number`
					target.querySelector(
						".credential_register_number"
					).name = `forms_combined_schools_purchase_applications_edit[credentials_attributes][${clone_length}][c_register_number]`
					target.querySelector(".republish_reason").value = republish_reason
					target.querySelector(
						".republish_reason"
					).id = `forms_combined_schools_purchase_applications_edit_credentials_attributes_${clone_length}_republish_reason`
					target.querySelector(
						".republish_reason"
					).name = `forms_combined_schools_purchase_applications_edit[credentials_attributes][${clone_length}][republish_reason]`
					target.style = ""
					this.credential_templateTarget.append(target)
				}
			})
	}

	fetchRelearningItemSearch(item_id, target) {
		const query = new URLSearchParams()
		query.set("q[id_eq]", item_id)
		fetch(`${this.purchaseItemSearchUrlValue}?${query}`)
			.then((response) => response.json())
			.then((data) => {
				let amount_value = ``
				data.forEach((item) => {
					amount_value = `${item.amount}`
				})
				target.querySelector(".relearning_amount").textContent = amount_value
			})
	}

	fetchRelearningSearchUser(
		register_number,
		purchase_item_id,
		clone_course_name,
		target,
		clone_length
	) {
		const query = new URLSearchParams()
		query.set("register_number", register_number)
		fetch(`${this.purchaseUserSearchUrlValue}?${query}`)
			.then((response) => response.text())
			.then((data) => {
				if (data == "") {
					alert("対象の学生が存在しません。")
					return false
				} else {
					let user_name = data
					target.querySelector(".relearning_student_name").textContent =
						user_name
					target.querySelector("input").value = clone_length
					target.querySelector(".relearning_register_number").value =
						register_number
					target.querySelector(
						".relearning_register_number"
					).id = `forms_combined_schools_purchase_applications_edit_relearnings_attributes_${clone_length}_r_register_number`
					target.querySelector(
						".relearning_register_number"
					).name = `forms_combined_schools_purchase_applications_edit[relearnings_attributes][${clone_length}][r_register_number]`
					target.querySelector(".purchase_item_id").value = purchase_item_id
					target.querySelector(
						".purchase_item_id"
					).id = `forms_combined_schools_purchase_applications_edit_relearnings_attributes_${clone_length}_purchase_item_id`
					target.querySelector(
						".purchase_item_id"
					).name = `forms_combined_schools_purchase_applications_edit[relearnings_attributes][${clone_length}][purchase_item_id]`
					target.querySelector(".course_name").textContent = clone_course_name
					this.fetchRelearningItemSearch(purchase_item_id, target)
					target.style = ""
					this.relearning_templateTarget.append(target)
				}
			})
	}

	textFormSubmit() {
		this.text_submitTarget.click()
	}

	credentialFormSubmit() {
		this.credential_submitTarget.click()
	}

	relearningFormSubmit() {
		this.relearning_submitTarget.click()
	}

	changeFacultyOfLawTab() {
		const junior_college_elems = document.getElementsByClassName(
			"item-faculty-junior-college"
		)
		const law_elems = document.getElementsByClassName("item-faculty-law")
		for (let i = 0; i < junior_college_elems.length; i++) {
			junior_college_elems[i].style = "display:none;"
		}
		for (let j = 0; j < law_elems.length; j++) {
			law_elems[j].style = ""
		}
		this.law_tabTarget.classList.add("active")
		this.junior_College_tabTarget.classList.remove("active")
	}

	changeJuniorCollegeTab() {
		const junior_college_elems = document.getElementsByClassName(
			"item-faculty-junior-college"
		)
		const law_elems = document.getElementsByClassName("item-faculty-law")
		for (let i = 0; i < junior_college_elems.length; i++) {
			junior_college_elems[i].style = ""
		}
		for (let j = 0; j < law_elems.length; j++) {
			law_elems[j].style = "display:none;"
		}
		this.law_tabTarget.classList.remove("active")
		this.junior_College_tabTarget.classList.add("active")
	}
}
